import { InspectionScheduleType } from '@main-application/inspections/models/rest-inspections-model.interface';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { EnumerationItem } from '@shared/interfaces/enumeration-item';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

import { CustomNotificationFieldType } from '../components/inspection-add-dialog/custom-notifications-dialog/custom-notifications-dialog.component';

const DAYS = [-90, -75, -60, -45, -30, -14, -7, -3, -2, -1, 0, 1, 2, 3, 7, 14, 30, 45, 60, 75, 90];
const DAYS_FOR_MOVE_OUT = [-7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 14, 30, 60];
const DAYS_FOR_CREATE_OR_NOTIFY_FOR_NOTICE = [-60, -30, -14, -7, -3, -2, -1, 0];
const EXPIRE_DAYS = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
const REMIND_DAYS = [0, -7, -6, -5, -4, -3, -2, -1, 1, 2, 3, 4, 5, 6, 7];
const REMIND_THEN_DAYS = [1, 2, 3];
const UNTIL_DAYS = [3, 5, 10];

export const GetDynamicInspectionType = (
  dynamicScheduleType: InspectionScheduleType,
  workflowSteps: EnumerationItem[]
): string => {
  let type = '';
  switch (dynamicScheduleType) {
    case InspectionScheduleType.DynamicMoveIn: {
      const step = workflowSteps.find(s => s.enumerationValue === WorkflowStepEnumType.MoveIn);
      type = step.displayText.toUpperCase();
      break;
    }
    case InspectionScheduleType.DynamicMakeReady: {
      const step = workflowSteps.find(s => s.enumerationValue === WorkflowStepEnumType.MakeReady);
      type = step.displayText.toUpperCase();
      break;
    }
    default: {
      const step = workflowSteps.find(s => s.enumerationValue === WorkflowStepEnumType.MoveOut);
      type = step.displayText.toUpperCase();
    }
  }
  return type;
};

export const GetDynamicInspectionNotifyListConst = (
  dynamicScheduleType: InspectionScheduleType,
  workflowSteps: EnumerationItem[]
): IRadioButtonOption<number>[] => {
  const type = GetDynamicInspectionType(dynamicScheduleType, workflowSteps);

  if (dynamicScheduleType === InspectionScheduleType.DynamicMoveOut) {
    return DAYS_FOR_MOVE_OUT.map((d, index) => ({
      label: d === 0 ? `on ${type}` : d < 0 ? `${Math.abs(d)}d before ${type}` : `${d}d after ${type}`,
      value: d,
      sort: index,
    }));
  }

  return DAYS.map((d, index) => ({
    label: d === 0 ? `on ${type}` : d < 0 ? `${Math.abs(d)}d before ${type}` : `${d}d after ${type}`,
    value: d,
    sort: index,
  }));
};

export const GetInspectionExpireListConst = (label = 'never'): IRadioButtonOption<number>[] => {
  return EXPIRE_DAYS.map((d, index) => ({
    label: d === -1 ? label : d === 0 ? 'on due date' : d < 0 ? `${Math.abs(d)}d before` : `${d}d after`,
    value: d,
    sort: index,
  }));
};

export const GetInspectionNotifyListConst = (): IRadioButtonOption<number>[] => {
  return DAYS.map((d, index) => ({
    label: d === 0 ? 'On due date' : d < 0 ? `${Math.abs(d)}d before due date` : `${d}d after due date`,
    value: d,
    sort: index,
  }));
};

export const GetDaysForCreateOrNotifyForNotice = (label = 'MOVE OUT'): IRadioButtonOption<number>[] => {
  const options = DAYS_FOR_CREATE_OR_NOTIFY_FOR_NOTICE.map((d, index) => ({
    label: d === 0 ? `on ${label}` : `${Math.abs(d)}d before ${label}`,
    value: d,
    sort: index,
  }));
  options.unshift({
    label: 'As soon as NOTICE filed',
    value: -999,
    sort: -1,
  });
  return options;
};

export const GetInspectionRemindListConst = (field: CustomNotificationFieldType): IRadioButtonOption<number>[] => {
  let days = REMIND_DAYS;
  switch (field) {
    case 'notifyOn':
      days = [0];
      break;

    case 'thenRemindOn':
      return REMIND_THEN_DAYS.map((d, index) => ({
        label: d === 1 ? 'Daily' : `Every ${d}d`,
        value: d,
        sort: d,
      }));

    case 'until':
      return UNTIL_DAYS.map((d, index) => ({
        label: `${d} times`,
        value: d,
        sort: d,
      }));
  }
  return days.map((d, index) => ({
    label: d === 0 ? 'On due date' : d < 0 ? `${Math.abs(d)}d before due date` : `${d}d after due date`,
    value: d,
    sort: index,
  }));
};
